var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAvatarIcon = function SvgAvatarIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.82422C7.79086 8.82422 6 10.6151 6 12.8242V24.8242C6 27.0334 7.79086 28.8242 10 28.8242H26C28.2091 28.8242 30 27.0334 30 24.8242V12.8242C30 10.6151 28.2091 8.82422 26 8.82422H10ZM15.438 14.6551C15.438 13.0917 16.7054 11.8242 18.2689 11.8242C19.8324 11.8242 21.0998 13.0917 21.0998 14.6551C21.0998 16.2186 19.8324 17.4861 18.2689 17.4861C16.7054 17.4861 15.438 16.2186 15.438 14.6551ZM14.0602 19.5308C14.3816 18.8096 15.0973 18.345 15.8869 18.345H20.6508C21.4405 18.345 22.1562 18.8096 22.4776 19.5308L23.3633 21.5178C23.8919 22.7038 23.1678 24.0712 21.8898 24.3006L18.6222 24.8871C18.3885 24.929 18.1492 24.929 17.9156 24.8871L14.648 24.3006C13.3699 24.0712 12.6459 22.7038 13.1745 21.5178L14.0602 19.5308Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "avatar-icon.fb8af30854d3a685704be8a90b2a36da.svg";